import useBreakPoint from 'hooks/useBreakPoint';
import Select from 'react-select';

function SelectInput({
    options, setOption, value
}) {
    const { isBreakpointActive: isMobile } = useBreakPoint();
    return(
        <Select 
        options={options} 
        value={value}
        onChange={setOption}
        styles={{
            control: (baseStyles, state) => ({
                ...baseStyles,
                fontSize: '1.12rem',
                width: isMobile ? '160px' : '280px',
                padding: '6px 10px',
                borderRadius: '20px',
            }),
            option: (styles, { data, isDisabled, isFocused, isSelected }) => (
            {
                ...styles,
                fontSize: '1rem',
                color: 'black',
            })
        }} 
        theme={(theme) => ({
            ...theme,
            borderRadius: 6,
            colors: {
            ...theme.colors,
            primary25: '#fbfbfb',
            primary: 'rgba(218, 41, 28, 0.2)',
            },
          })}/>
    )
}

export default SelectInput;